import classNames     from 'classnames';
import React, { FC }  from 'react';
import { ClassValue } from "classnames/types";


export const FieldDescription: FC<{ className?: ClassValue }> = ( { children, ...props } ) => {

    return (
        <p className={ classNames( 'text--muted', props.className ?? {} ) }>

            { children }

        </p>
    )
};
